import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=db0e4c60&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db0e4c60')) {
      api.createRecord('db0e4c60', component.options)
    } else {
      api.reload('db0e4c60', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=db0e4c60&", function () {
      api.rerender('db0e4c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z2F5L93I5LCO/JS/pricehelp.vue"
export default component.exports